export default "__VITE_ASSET__vi5hA8S7__"